/**
 * @copyright Copyright 2015-2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/DropDownButton",
    "MW/toolstrip/mixins/property/MnemonicMixin",
    "MW/toolstrip/mixins/property/MnemonicKeyNavDirectionMixin",
    "MW/toolstrip/mixins/property/IconMixin",
    "MW/toolstrip/mixins/property/IconOverrideMixin",
    "MW/toolstrip/mixins/property/TextMixin",
    "MW/toolstrip/mixins/property/SizeMixin",
    "MW/toolstrip/form/mixins/property/DropDownButtonSizeMixin",
    "MW/toolstrip/form/mixins/property/DropDownButtonTextMixin",
    "MW/toolstrip/mixins/property/OrientationMixin",
    "MW/toolstrip/mixins/property/TextOverrideMixin",
    "MW/toolstrip/mixins/property/DescriptionOverrideMixin",
    "MW/toolstrip/mixins/property/TypeMixin",
    "mw-form/mixins/property/ShortcutMixin",
    "MW/toolstrip/mixins/property/QuickAccessIconMixin",
    "MW/toolstrip/mixins/property/MenuIdMixin",
    "MW/toolstrip/mixins/property/MenuMixin",
    "MW/toolstrip/mixins/property/PreventRestoreFocusMixin",
    "MW/toolstrip/mixins/property/TooltipMixin",
    "MW/toolstrip/mixins/property/ShowTextMixin",
    "MW/toolstrip/form/mixins/property/DropDownLikeButtonA11yMixin",
    "mw-form/mixins/mixinDependencyValidator"
], function (declare, DropDownButton, MnemonicMixin, MnemonicKeyNavDirectionMixin, IconMixin, IconOverrideMixin,
             TextMixin, SizeMixin, DropDownButtonSizeMixin, DropDownButtonTextMixin, OrientationMixin, TextOverrideMixin,
             DescriptionOverrideMixin, TypeMixin, ShortcutMixin, QuickAccessIconMixin, MenuIdMixin, MenuMixin,
             PreventRestoreFocusMixin, TooltipMixin, ShowTextMixin, DropDownLikeButtonA11yMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([DropDownButton, MnemonicMixin, MnemonicKeyNavDirectionMixin,
        IconMixin, IconOverrideMixin, TextMixin, SizeMixin, DropDownButtonSizeMixin, DropDownButtonTextMixin,
        OrientationMixin, TextOverrideMixin, DescriptionOverrideMixin, TypeMixin, ShortcutMixin, QuickAccessIconMixin,
        MenuIdMixin, MenuMixin, PreventRestoreFocusMixin, TooltipMixin, ShowTextMixin, DropDownLikeButtonA11yMixin]), {
        visualFamily: "default",
        minWidth: 38,

        /**
         * Get the array of title nodes.
         * @returns {Array}
         */
        getTitleNodes: function() {
            return [this.focusNode];
        }
    });

});
